import React from "react";

const errorMessage = ({ error }) => {
  if (!error) return null;
  return <p className="text-danger m-0">{error}</p>;
};

export default errorMessage;